{
  "nl": {
    "quiz": {
      "correctAnswers": "{count} juist | {count} juist",
      "finish": "Voltooien",
      "incorrectAnswers": "{count} fout | {count} fout",
      "next": "Volgende",
      "resultsTitle": "Quizresultaat",
      "step": "Stap {current} van {total}",
      "tryAgain": "Opnieuw proberen"
    }
  }
}
